import { Text } from '@mantine/core';

import { TRACKING_CONFIGS } from '../../constants/conversionTracking';
import { isTrackingComplete } from '../../utils/getStepStructure';
import ErrorBox from './ResultBox/ErrorBox';

import type { IFileUploadStatus } from '../../../../../../../../shared/apis/ai-agent/file/types';

interface IPropsAsCsConversionResult {
  uploadHistory: Pick<IFileUploadStatus, 'failYn' | 'failReason' | 'status'>;
}

export default function AsCsConversionResult(props: IPropsAsCsConversionResult) {
  const { uploadHistory } = props;
  const { failYn, failReason, status } = uploadHistory;

  if (failYn === 'Y') {
    return (
      <>
        <Text fw={500} mb="xs">
          문서 변환 진행 결과
        </Text>
        <ErrorBox result={{ errorMessage: failReason }} />
      </>
    );
  }

  if (failYn === 'N' && isTrackingComplete(TRACKING_CONFIGS.asCs, status)) {
    return null;
  }

  return null;
}
